import initialState from "./initial-state";
import { SET_BANNERS, SET_BANNERS_ERROR } from "../actions/action-types";
import { createReducer } from "./reducer-creator";

const setBanners = (state, { payload }) => {
  const orderedCategories = payload.sort(
    (a, b) => a.categoria.orden - b.categoria.orden
  );
  let defaultBanner = []
  let otherBanners = []

  defaultBanner = orderedCategories.filter(
    (item) => item.categoria.default
  ).sort(
    (a, b) => a.categoria.orden - b.categoria.orden
  )

  otherBanners = orderedCategories.filter(
    (item) => item.categoria.default === false
  )

  const newResponse = otherBanners.concat(defaultBanner)

  const categoriesMainCarousel = orderedCategories.reduce((acc, cur) => {
    const ubicacion = cur.categoria?.ubicacion;
    if (ubicacion && ubicacion.nombre === "slider-con-buscador-paquetes") {
      return acc.concat([cur]);
    }

    return acc;
  }, []);

  return {
    ...state,
    ready: true,
    raw: payload,
    categoriesMainCarousel: categoriesMainCarousel || [],
    categories: newResponse || [],
  };
};

const setBannersError = (state) => {
  return {
    ...state,
    ready: true,
    error: true,
  };
};

export default createReducer(initialState.bannersState, {
  [SET_BANNERS]: setBanners,
  [SET_BANNERS_ERROR]: setBannersError,
});
